import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/subscriptionpage.css';

const SubscriptionPage = () => {

  const navigate = useNavigate();

  const goToChangePassword = () => {
    navigate('/changepassword'); // 👈 match this with your route path
  }

  return (
    <div className="account-container">
      <aside className="sidebar">
        <div className="avatar" />
        <div className="menu">
          <button className="active">📄 Subscription</button>
          <button onClick={goToChangePassword}>🔑 Change Password</button>
          <button>🚪 Logout</button>
        </div>
      </aside>

      <div className="subscription-details">
        <table>
          <tbody>
            <tr><td>Status</td><td></td></tr>
            <tr className="alt"><td>Plan</td><td></td></tr>
            <tr><td>Amount</td><td></td></tr>
            <tr className="alt"><td>Start Date</td><td></td></tr>
            <tr><td>Renewal Date</td><td></td></tr>
            <tr className="alt"><td>Payment</td><td></td></tr>
            <tr>
              <td>Actions</td>
              <td>
                <button className="pay-btn">Renew</button>
                <button className="cancel-btn">Cancel</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default SubscriptionPage;
